import { type FunctionComponent, useState, useEffect } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import SV from 'server-vars';

// components
import { Link } from 'dibs-elements/exports/Link.tsx';
import Contact1stdibsModal from '../../contact1stdibs/Contact1stdibsModal.tsx';
import {
    getGetHelpZendeskLocalStorageState,
    isGetHelpModalZendeskVariant,
    resetGetHelpZendeskLocalStorageState,
} from 'dibs-contact-1stdibs/exports/getHelpHelpers.ts';

import styles from '../Footer/LinkColumn/LinkColumnItem.scss';

// helpers
import { trackNavigationClick } from '../../helpers/trackingHelpers.ts';

type Props = {
    trackingLabel: string;
};

const pageType = SV.get('settings.pageType');

const Contact1stdibsFooterLink: FunctionComponent<Props> = ({ trackingLabel }) => {
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);
    const [isPersistedContactModalOpen, setIsPersistedContactModalOpen] = useState(false);

    useEffect(() => {
        const isPdpPage = pageType === 'pdp';

        if (
            isGetHelpModalZendeskVariant() &&
            !!getGetHelpZendeskLocalStorageState()?.isOpen &&
            !isPdpPage
        ) {
            setIsPersistedContactModalOpen(true);
        }

        if (isPdpPage) {
            resetGetHelpZendeskLocalStorageState();
        }
    }, []);

    return (
        <li className={styles.item}>
            <Link
                onClick={event => {
                    setIsContactModalOpen(true);
                    trackNavigationClick({ label: trackingLabel }, event);
                }}
                className={styles.contact1stdibsLink}
                dataTn="footer-contact-1stdibs"
            >
                <FormattedMessage
                    id="dbl.Footer.site_links_contact_1stdibs"
                    defaultMessage="Get Help"
                />
            </Link>
            <Contact1stdibsModal
                isOpen={isContactModalOpen || isPersistedContactModalOpen}
                placement="globalFooter"
                onClose={() => {
                    if (isPersistedContactModalOpen) {
                        setIsPersistedContactModalOpen(false);
                    } else {
                        setIsContactModalOpen(false);
                    }
                }}
                isPersistedModal={isPersistedContactModalOpen}
            />
        </li>
    );
};

export default Contact1stdibsFooterLink;
